import React, { useState, useEffect } from 'react';
import { string, number } from 'prop-types';
import { get } from 'lodash';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import { Column } from '../Grid';
import { If } from '../../shared';
import Icon from '../Icon';
import { BLACK, GREEN_DARK } from '../../../utils/colors';
import HasPermissions from '../HasPermissions/HasPermissions';
import { Mutation } from '../../graphql';
import UPDATE_RECORD_VIEW_DOWNLOAD from '../../../queries/UPDATE_RECORD_VIEW_DOWNLOAD';
import { currentUserInfo } from '../../../utils/misc';

const AudioPlayer = ({ id, file, iconSize }) => {
    const [status, setStatus] = useState('play');
    const [audio, setAudio] = useState(null);
    const [percentage, setPercentage] = useState(0);

    const statusIcon = () => status === 'playing' ? 'pause' : 'circle-play';

    useEffect(() => {
        const initialAudio = new Audio(file);
        setAudio(initialAudio);

        return () => {
            initialAudio.pause();
            initialAudio.currentTime = 0;
          initialAudio.src = '';
        };
      }, []);

    useEffect(() => {
        const currentTimeInterval = callback => setInterval(callback, 1000);
        if (status === 'playing') {
            currentTimeInterval(() => {
                const { currentTime, duration } = audio;
                const currentPercentage = ((currentTime * 100) / duration);
                setPercentage(currentPercentage);
            });
        }
        clearInterval(currentTimeInterval);
    }, [status]);

    const onClickAudio = async () => {
        if (status === 'playing') {
            setStatus('paused');
            return audio.pause();
        }
        audio.oncanplaythrough = () => {
            setStatus('playing');
            return audio.play();
        };
        audio.onended = () => setStatus('play');
        await audio.oncanplaythrough();
    };

    const commonDivStyles = {
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        height: '28px',
        paddingTop: '1px'
    };

    return (
        <If
            condition={status}
            then={
                <FlexContainer>
                    <Mutation mutation={UPDATE_RECORD_VIEW_DOWNLOAD}>
                        {({ updateFn }) => {
                            const onClick = async (callback, type) => {
                                // type Enum
                                // 1 - seen
                                // 2 - downloaded
                                updateFn({
                                    variables: {
                                        input: {
                                            id,
                                            type,
                                            userId: get(await currentUserInfo(), 'email')
                                        }
                                    }
                                }).then(() => callback());
                            };
                            return (
                                <>
                                    <HasPermissions to={['order-detail-page:play-call-record']}>
                                        <Column justify='center'>
                                            <FlexContainer fixedWidth={iconSize} onClick={() => onClick(onClickAudio, 1)} pointer>
                                                <div style={{ width: `${100 - percentage}%`, ...commonDivStyles }}>
                                                    <Icon name={statusIcon()} size={iconSize} color={GREEN_DARK} />
                                                </div>
                                                <div style={{ width: `${percentage}%`, justifyContent: 'end', ...commonDivStyles }}>
                                                    <Icon name={statusIcon()} size={iconSize} color={BLACK} />
                                                </div>
                                            </FlexContainer>
                                        </Column>
                                    </HasPermissions>
                                    <HasPermissions to={['order-detail-page:download-call-record']}>
                                        <Column pL={20}>
                                            <Icon name='download' size={iconSize} color={GREEN_DARK} pointer onClick={() => onClick(() => window.open(file), 2)} />
                                        </Column>
                                    </HasPermissions>
                                </>
                            );
                        }}
                    </Mutation>
                </FlexContainer>
            }
        />
    );
};

AudioPlayer.propTypes = {
    file: string,
    iconSize: number,
    id: string
};

AudioPlayer.defaultProps = {
    file: null,
    iconSize: 25,
    id: '0'
};

export default AudioPlayer;
